import React, { useEffect, useState } from "react";
import { Row, Col, Popover } from "antd";
import CardComponent from "@/components/card";
import ButtonComponent from "@/components/button/Button";
import IconDots from "@/components/icons/IconDots";
import { Flex } from "antd";
import IconReport from "@/components/icons/IconReport";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch } from "react-redux";
import { crateReport } from "@/services/users/getReportCategory";
import { useNavigate } from "react-router-dom";
import { getGuideTasks } from "@/services/guides/getGuideTasks";
import { submitStudentTaskDocumentById } from "@/services/students/submitStudentTaskDocumentById";
import { uploadFile } from "@/services/users/uploadFile";
import { markTaskAsCompleted } from "@/services/common/task";
import "@/styles/tasks/task-details.scss";

const TaskDetails = ({ student, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);

  const onReportClick = (taskId) => {
    dispatch(setCurrentForm("report"));
    dispatch(
      setFormProps({
        categoryType: "Task",
        handleSubmit: (data) => {
          if (data.categoryId && data.description) {
            data.metadata = { taskId };
            crateReport(data).then((res) => {
              console.log(res);
              dispatch(setModalOpen(false));
              dispatch(setCurrentForm("successModal"));
              dispatch(setModalOpen(true));
              dispatch(
                setFormProps({
                  message: "Your report has been submitted successfully.",
                  btnLabel: "Close",
                  onSubmit: () => {
                    dispatch(setModalOpen(false));
                  },
                })
              );
            });
          }
        },
      })
    );
    dispatch(setModalOpen(true));
  };
  const isButtonDisabled = (item) => {
    if (isOwnTask(item)) {
      if (item.status !== "todo") {
        return true;
      }
    } else if (!item.completedAt || item.closedAt) {
      return true;
    }
    return false;
  };
  const isOwnTask = (item) => {
    return item.userId === item.assignedById;
  };
  const handleTaskSubmit = (item) => {
    const id = item.id;
    const limit = item.limit;
    if (item.progress !== "Submitted") {
      dispatch(setCurrentForm("dashboardDocChat"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          onSubmit: async (value) => {
            const files = [];
            let body = {};
            if (value?.file?.fileList?.length > 0) {
              const uploadPromises = value.file?.fileList?.map(async (fileItem) => {
                const formData = new FormData();
                formData.append("file", fileItem.originFileObj);

                return uploadFile(-1, formData)
                  .then((res) => {
                    files.push(res);
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              });

              await Promise.all(uploadPromises);
              body = {
                comment: value.comment ?? "",
                files: files,
              };
            } else {
              console.log("No files to upload");
              body = {
                comment: value.comment ?? "",
              };
            }
            if (isOwnTask(item)) {
            }
            submitStudentTaskDocumentById(id, body)
              .then((res) => {
                fetchTasks(student.id);
                dispatch(setModalOpen(false));
              })
              .catch((err) => console.log(err));
          },
          limit: limit,
          isComment: !item.fileCategoryId,
        })
      );
    }
  };
  const markTaskAsComplete = (id) => {
    dispatch(setCurrentForm("confirmDelete"));
    dispatch(setModalOpen(true));
    dispatch(
      setFormProps({
        message: "Mark this task as completed?",
        onSubmit: () => {
          markTaskAsCompleted(id).then((res) => {
            dispatch(setModalOpen(false));
            fetchTasks(student.id);
          });
        },
      })
    );
  };
  const handleGuideSubmit = (item) => {
    const id = item.id;
    const limit = item.limit;
    console.log(limit);
    if (item.progress === "Submitted") {
      markTaskAsComplete(id);
    } else {
      handleTaskSubmit(item);
    }
  };
  const getTaskLabel = (item) => {
    if (isOwnTask(item)) {
      return item.status === "todo" ? "Complete Task" : "Completed";
    }
    return item.status === "completed" ? "Completed" : "Mark as Completed";
  };

  const content = ({ id }) => {
    return (
      <div className="menulink-popover">
        <Flex
          align="center"
          gap="0.5rem"
          className="color-brand cursor-pointer"
          onClick={() => {
            // dispatch(setModalOpen(true))
          }}
        >
          <IconReport />
          <span onClick={() => onReportClick(id)}>Report</span>
        </Flex>
      </div>
    );
  };
  const formatTasks = (tasks) => {
    return tasks.map((task) => {
      const deadlineDate = task.deadline ? new Date(task.deadline) : null;
      const isOverdue = deadlineDate && deadlineDate < new Date();
      return {
        ...task,
        id: task.id,
        progress: task.closedAt
          ? "Completed"
          : task.completedAt
            ? "Submitted"
            : isOverdue
              ? "Overdue"
              : "To Do",
        value: task.closedAt
          ? "Completed"
          : task.completedAt
            ? "Submitted"
            : isOverdue
              ? "Overdue"
              : "To Do",
        title: task.title,
        description: task.description,
        taskId: task.taskId,
        ownerId: task.ownerId,
        closedAt: task.closedAt,
        totalLimit: task.totalLimit ?? 0, // Added fallback for missing fields
        currentLimit: task.currentLimit ?? 0, // Added fallback for missing fields
        deadline: deadlineDate
          ? deadlineDate.toLocaleDateString("en-GB", {
              weekday: "long",
              day: "numeric",
              month: "short",
            })
          : "No deadline",
        assignedById: task.assignedBy,
        userId: task.userId,
        status: task.status,
      };
    });
  };

  const fetchTasks = (studentId) => {
    getGuideTasks(studentId)
      .then((res) => {
        const tasksArray = res["0"]?.tasks || [];
        const formattetdTasks = formatTasks(tasksArray);
        setTasks(formattetdTasks);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (student && student.id) {
      fetchTasks(student.id);
    }
  }, [student]);

  const TaskCard = ({ item, index }) => {
    return (
      <Col sm={12} xs={24} key={item.id} className="carousel-item">
        <CardComponent>
          <div className="task">
            <div className="task-content">
              <Flex className="task-number body-b4" align="center" justify="space-between">
                <div>
                  {item.title.length > 40 ? `${item.title.substring(0, 40)}...` : item.title}
                </div>
                <Popover
                  placement="bottomRight"
                  content={content({
                    id: item.id,
                  })}
                  trigger="hover"
                  onClick={(e) => e.stopPropagation()}
                >
                  <IconDots className="cursor-pointer" on />
                </Popover>
              </Flex>
              <div
                className="task-content"
                onClick={() => navigate(`/dashboard/comments/${item.id}`)}
              >
                {item.progress === "Overdue" ? (
                  <div className="progress-red">{item.progress}</div>
                ) : (
                  <div className="progress">{item.progress}</div>
                )}
                <div className="task-name body-b1-2">
                  {item.description.length > 50
                    ? `${item.description.substring(0, 50)}...`
                    : item.description}
                </div>
                <div className="deadline body-b4">
                  Deadline: <span>{item.deadline}</span>
                </div>
              </div>
              <div className="submit-button">
                <ButtonComponent
                  label={getTaskLabel(item)}
                  disabled={isButtonDisabled(item)}
                  varient="success"
                  onClick={() => handleGuideSubmit(item)}
                />
              </div>
            </div>
          </div>
        </CardComponent>
      </Col>
    );
  };
  return (
    <div>
      <div className="tasks">
        <Row gutter={[12, 12]}>
          {tasks?.map((task, index) => (
            <TaskCard item={task} index={index} key={index} />
          ))}
        </Row>
      </div>
    </div>
  );
};

export default TaskDetails;
